var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"id":"CloseIcon","key":0},"Close icon"),React.createElement("desc",{"id":"Collapse","key":1},"An icon that collapse the menu options"),React.createElement("path",{"d":"M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z","fill":"#323232","key":2})]);
}

CloseInline.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
